import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'glass' | 'cyan' | 'green' | 'dark';
  glow?: boolean;
}

export function Card({
  children,
  className = '',
  variant = 'glass',
  glow = false,
  ...props
}: CardProps) {
  const base = 'rounded-2xl border transition-all duration-300';

  const variants = {
    glass: 'bg-white/[0.02] backdrop-blur-xl border-white/[0.06]',
    cyan:  'bg-[#080a0f]/80 backdrop-blur-xl border-cyberCyan/20',
    green: 'bg-[#080a0f]/80 backdrop-blur-xl border-cyberGreen/20',
    dark:  'bg-[#030508]/90 border-white/[0.04]',
  };

  const glows = {
    glass: '',
    cyan:  'shadow-cyanGlow border-cyberCyan/40',
    green: 'shadow-greenGlow border-cyberGreen/40',
    dark:  '',
  };

  return (
    <div
      className={`${base} ${variants[variant]} ${glow ? glows[variant] : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
